const PAN_PADDING_PX = 8;

export const moveMapPinIntoView = (map: google.maps.Map, timeout = 0) => {
  // Needs to run after popper renders
  setTimeout(() => {
    const pin = document.querySelector('.pin.active');
    const popper = document.querySelector('#partner-details');

    if (!pin || !popper) return;

    const pinBox = pin.getBoundingClientRect();
    const popperBox = popper.getBoundingClientRect();
    const pinOverlapped =
      Math.min(pinBox.right, popperBox.right) >
        Math.max(pinBox.left, popperBox.left) &&
      Math.min(pinBox.bottom, popperBox.bottom) >
        Math.max(pinBox.top, popperBox.top);

    if (!pinOverlapped) return;

    const panX = Math.floor(pinBox.left - popperBox.right - PAN_PADDING_PX);
    map.panBy(panX, 0);
  }, timeout);
};
